import React, { useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Label,
  FormFeedback,
  Form,
} from "reactstrap";

// Redux
import { useDispatch } from "react-redux";
import {  postProduct,delProductImg, fetchProductCategories } from '../../utils/products';

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import classnames from "classnames";
import Dropzone from "react-dropzone";
import { Link, useNavigate } from "react-router-dom";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import { baseURL, addProductImage, addProductImageList } from "../../utils/imageapi";
import { ToastContainer, toast } from 'react-toastify';
import { getNfcByUid,nfcAll,nfcAdd } from "../../utils/nfc";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const AddProduct = (props) => {
  document.title = "Create Product | SeedNations";
 

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
   
  const [nfcId, setNfcId] = useState(null);

  const [batteryRequired, setBatteryRequired] = useState(null);
  const [selectedNft, setSelectedNft] = useState(null); 
  const [nftLink, setNftLink] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedVisibility, setselectedVisibility] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [editor, setEditor] = useState(null);
  const [about, setAbout] = useState('');

  const [mainImageUrl, setMainImageUrl] = useState(""); // Store uploaded main image URL 
  // Function to handle main product image upload
  const handleMainImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    formData.append("is_main_image", 1); 

    try {
       
      const response = await addProductImage(formData);
      // const response = await axios.post("/api/upload", formData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      if (response.filename) {
        setMainImageUrl(`${baseURL}/file/product/image/${response.filename}`); // Store uploaded image URL
      }
    } catch (error) {
      console.error("Upload main image failed:", error);
    } finally {
      setIsUploading(false);
    }
  };


const handleImageListUpload = async (files) => {
    if (!files.length) return;

    const formData = new FormData();
    
    // Append multiple files
    files.forEach(file => {
        formData.append("file", file);
    });

    const response = await addProductImageList(formData);

    if (response && response.success) {
        // Map response URLs back to the original file object schema
        const updatedFiles = files.map((file, index) => ({
            ...file,
            id: file.id,
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size),
            url: response.images[index]?`${baseURL}/file/product/image/${response.images[index]}`: file.url, // Use returned URL if available
            filename: response.images[index]
        }));

        setSelectedFiles(updatedFiles);
    }
};


  async function deleteImg(filename){
    try {
        const response = await delProductImg(filename);
      
      // Check if response exists and has expected structure
      if (!response) {
        throw new Error('No response received from server');
      }
  
      // Handle successful response
      if (response.success) {
        alert("Product delete successfully");
        // Optionally reset form or redirect
        // validation.resetForm();
        // navigate('/products'); // If you want to redirect after success
      } else {
        // Handle API error with message
        alert(response.message || "Failed to delete product. Please try again.");
      }
    } catch (err) {
      console.error('Submission failed:', err);
      
      // User-friendly error message
      alert(
        err.response?.message || 
        err.message || 
        'Failed to delete product. Please check your connection and try again.'
      );
    }
  }
  function handleSelectNft(selectedNft) { 
    setSelectedNft(selectedNft);
}


  function handleSelectNftLink(selectedValue) {  
    setNftLink(selectedValue);
  }

  function handleSelectBatteryRequired(selectedOption) { 
    setBatteryRequired(selectedOption);
  }
  function handleSelectVisibility(selectedVisibility) {
    setselectedVisibility(selectedVisibility);
  }
  function handleSelectNft(selectedNft) { 
    setSelectedNft(selectedNft);
}
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


// Function to process the product categories
const productCategoryList = async () => {
  let return_d = [];

  try {
    const data = await fetchProductCategories();

    if (data.data) {
      // Function to recursively build the label based on parent_id
      const buildLabel = (element, categories) => {
        const parents = [];
        let current = element;

        while (current.parent_id) {
          const parent = categories.find((cat) => cat.id === current.parent_id);
          if (parent) {
            parents.unshift(parent.name); // Add the parent name to the beginning of the list
            current = parent;
          } else {
            break; // Exit if the parent is not found
          }
        }

        return [...parents, element.name].join(" / "); // Combine parent names with category name
      };

      // Map API data to the required format
      return_d = data.data.map((element) => ({
        label: buildLabel(element, data.data), // Call the helper function to construct the label
        value: element.name,
      }));
    }
  } catch (error) {
    console.error("Error loading product categories:", error);
    // Default fallback categories
    return_d = [
      { label: "All", value: "All" },
      { label: "Appliances", value: "Kitchen Storage & Containers" },
      { label: "Fashion", value: "Clothes" },
      { label: "Electronics", value: "Electronics" },
      { label: "Grocery", value: "Grocery" },
      { label: "Home & Furniture", value: "Furniture" },
      { label: "Kids", value: "Kids" },
      { label: "Mobiles", value: "Mobiles" },
    ];
  } finally {
    return return_d;
  }
};


// React useEffect to populate product categories
const [productCategory, setProductCategory] = React.useState([
  {
    options: [
      { label: "All", value: "All" }, // Default initial option
    ],
  },
]);

React.useEffect(() => {
  const loadCategories = async () => {
    const options = await productCategoryList();
    console.log(options);
    setProductCategory([{ options }]); // Update productCategory with fetched data
  };

  loadCategories();
}, []);


  const yesOrNo = [
    {
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],
    },
  ];

  const dateFormat = () => {
    let d = new Date(),
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let h = (d.getHours() % 12) || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return ((d.getDate() + ' ' + months[d.getMonth()] + ', ' + d.getFullYear() + ", " + h + ":" + d.getMinutes() + " " + ampm).toString());
  };

  const [date, setDate] = useState(dateFormat());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");
    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = (H % 12) || 12;
    h = (h <= 9) ? h = ("0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  }; 
  const productStatus = [
    {
      options: [
        { label: "Draft", value: "draft" },
        { label: "Published", value: "published" },
        { label: "Scheduled", value: "scheduled" },
      ],
    },
  ];

  const productVisibility = [
    {
      options: [
        { label: "Hidden", value: "Hidden" },
        { label: "Public", value: "Public" },
      ],
    },
  ];
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
   
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: { 
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter a Product Title"),
      price: Yup.string().required("Please Enter a Product Price"),
      stock: Yup.string().required("Please Enter a Product stock"),
      orders: Yup.string().required("Please Enter a Product orders"),
      category: Yup.string().required("Please Enter a Product category"),
      status: Yup.string().required("Please Enter a Product status"),
      manufacturer_name: Yup.string().required("Please Enter a Manufacturer Name"),
      manufacturer_brand: Yup.string().required("Please Enter a Manufacturer Brand"),
      productDiscount: Yup.string().required("Please Enter a Product Discount"),
      sku:Yup.string().required("Please Enter a Product SKU"),
      product_tags: Yup.string().required("Please Enter a Product Tags"),
      nft:Yup.string().typeError().strict(true),
      nftLink:Yup.string().typeError().strict(true),
      batteryRequired: Yup.string().typeError().strict(true),
    }),  
     
  });

  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try { 

      const newProduct = {
        _id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
        name: values.name,
        price: values.price,
        stock: values.stock,
        orders: values.orders,
        category: values.category,
        publishedDate: date,
        status: values.status,
        rating: 4.5,
        nft:selectedNft?selectedNft.value:null,
        nft_link:nftLink?nftLink.value:null, 
        about:about,  
        manufacturer_name: values.manufacturer_name,
        manufacturer_brand: values.manufacturer_brand,
        releaseNumber:values.releaseNumber,
        price:values.price,
        productDiscount:values.productDiscount, 
        sku:values.sku, 
        ntagId:values.ntagId,
        type:values.type,
        boxContent:values.boxContent,
        brand:values.brand,
        subBrand:values.subBrand,
        series:values.series, 
        batteryRequired:values.batteryRequired,
        baterryType:values.baterryType,
        batteryCapacity:values.batteryCapacity,
        ageLimit:values.ageLimit,
        genre:values.genre,
        color:values.color,
        artist:values.artist,
        artistLink:values.artist_link,
        affiliation:values.affiliation,
        madeIn:values.madeIn,
        category:values.category,
        weight:values.weight,
        productDimension:values.productDimension,
        boxSize:values.boxSize,
        shippingWeight:values.shippingWeight,
        vendorId:values.vendorId,
        date:values.date,
        material:values.material, 
        selectedVisibility:selectedVisibility,
        publishedDate:values.publishedDate,
        product_tags: values.product_tags,
        product_short_description: values.product_short_description,
        product_main_image: mainImageUrl.substring(mainImageUrl.lastIndexOf('/') + 1),
        product_other_images: selectedFiles.map((file) => {
                                return file.url.substring(file.url.lastIndexOf('/') + 1);
                              })
      };
  
      // Make API call with error handling
      const response = await postProduct(newProduct);
      
      // Check if response exists and has expected structure 
      // Handle successful response
      if (response.status==200) {
        debugger
        if(values.ntagId){
          const param={
            tag_type:"product",
            assigned_id:response.data.product.id,
            uid:values.ntagId 
        }
         const response2 =  await  nfcAdd(param); 
         if(response2.status==200){
          successnotify("Product added successfully");
          navigate('/product-list'); 
         }
        } 
        // Optionally reset form or redirect
        // validation.resetForm();
        // navigate('/products'); // If you want to redirect after success
      } else {
        // Handle API error with message
          errornotify(response.error || "Failed to add product. Please try again.")  
      }
  
    } catch (err) {
      console.error('Submission failed:', err);
      errornotify(err.response?.message || 
        err.message || 
        'Failed to add product. Please check your connection and try again.') 
      
      // User-friendly error message
      
    }
  }; 
  return (
    <div className="page-content">
      <Container fluid>
      <ToastContainer />
        <BreadCrumb title="Create Product" pageTitle="Ecommerce" />

        <Row>
          <Col xl={8} lg={8} md={12} sm={12}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                console.log('onsubmit');
                //  
                console.log(validation.values);
                handleSubmit(validation.values);
                return false;
              }}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="product-title-input">
                      Product Title
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="product-title-input"
                      placeholder="Enter product title"
                      name="name"
                      value={validation.values.name || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={validation.errors.name && validation.touched.name ? true : false}
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                    ) : null}
                  </div>
                  <div>
                    <Label>Product Back Story</Label>

                    <CKEditor
                      value={validation.values.about || ""}
                      editor={ClassicEditor}
                      data=""
                      onReady={(editorInstance) => {
                        setEditor(editorInstance); // 保存编辑器实例
                      }} 
                      
                      onChange={(event,editor) => { 
                       const data= editor.getData();
                       if(data){
                        setAbout(data)
                       }
                    }}
                    />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Gallery</h5>
                </CardHeader>
                <CardBody>
                  {/* <div className="mb-4">
                    <h5 className="fs-15 mb-1">Product Image</h5>
                    <p className="text-muted">Add Product main Image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <label htmlFor="product-image-input" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="" data-bs-original-title="Select Image">
                            <div className="avatar-xs">
                              <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </label>
                          <input className="form-control d-none" defaultValue="" id="product-image-input" type="file" accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded">
                            <img src="" id="product-img" alt="" className="avatar-md h-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* Product Image Upload */}
                  <div className="mb-4">
                    <h5 className="fs-15 mb-1">Product Image</h5>
                    <p className="text-muted">Upload the main product image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <label htmlFor="product-image-input" className="mb-0">
                            <div className="avatar-xs">
                              <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </label>
                          <input
                            className="form-control d-none"
                            id="product-image-input"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleMainImageUpload}
                          />
                        </div>
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded">
                            {mainImageUrl ? (
                              <img
                                src={mainImageUrl}
                                alt="Product"
                                className="avatar-md h-auto"
                              />
                            ) : (
                              <p className="text-muted">No image selected</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end main  */}
                  <div>
                    <h5 className="fs-15 mb-1">Product Gallery</h5>
                    <p className="text-muted">Add Product Gallery Images.</p>

                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleImageListUpload(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <div className="mb-3">
                              <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                            </div>
                            <h5>Drop files here or click to upload.</h5>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="list-unstyled mb-0" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to={f.url}
                                    target="_blank"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                                <Col>
                                  <i  onClick={() => {
                                      deleteImg(f.filename);
                                    }} className="ri-delete-bin-2-line float-end"></i>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        General Info
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        Meta Data
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>

                <CardBody>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="1">
                      <Row>
                        <Col lg={6} md={12} sm={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="manufacturer-name-input"
                            >
                              Manufacturer Name
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="manufacturer-name-input"
                              name="manufacturer_name"
                              placeholder="Enter manufacturer name"
                              value={validation.values.manufacturer_name || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.errors.manufacturer_name && validation.touched.manufacturer_name ? true : false}
                            />
                            {validation.errors.manufacturer_name && validation.touched.manufacturer_name ? (
                              <FormFeedback type="invalid">{validation.errors.manufacturer_name}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col lg={6} md={12} sm={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="manufacturer-brand-input"
                            >
                              Manufacturer Brand
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="manufacturer-brand-input"
                              name="manufacturer_brand"
                              placeholder="Enter manufacturer brand"
                              value={validation.values.manufacturer_brand || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.errors.manufacturer_brand && validation.touched.manufacturer_brand ? true : false}
                            />
                            {validation.errors.manufacturer_brand && validation.touched.manufacturer_brand ? (
                              <FormFeedback type="invalid">{validation.errors.manufacturer_brand}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={3} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-stock-input"
                            >
                              release_number 
                            </label>
                            <div className="input-group mb-3">
                              <Input
                                type="text"
                                className="form-control"
                                id="product-stock-input"
                                placeholder="Enter release_number"
                                name="releaseNumber"
                                value={validation.values.releaseNumber || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.releaseNumber && validation.touched.releaseNumber ? true : false}
                              />
                              {validation.errors.releaseNumber && validation.touched.releaseNumber ? (
                                <FormFeedback type="invalid">{validation.errors.releaseNumber}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col lg={3} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-price-input"
                            >
                              Price
                            </label>
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text"
                                id="product-price-addon"
                              >
                                $
                              </span>
                              <Input
                                type="text"
                                className="form-control"
                                id="product-price-input"
                                placeholder="Enter price"
                                name="price"
                                aria-label="Price"
                                aria-describedby="product-price-addon"
                                value={validation.values.price || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.price && validation.touched.price ? true : false}
                              />
                              {validation.errors.price && validation.touched.price ? (
                                <FormFeedback type="invalid">{validation.errors.price}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col lg={3} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-Discount-input"
                            >
                              Discount
                            </label>
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text"
                                id="product-Discount-addon"
                              >
                                %
                              </span>
                              <Input
                                type="text"
                                className="form-control"
                                id="product-Discount-input"
                                placeholder="Enter Discount"
                                name="productDiscount"
                                aria-label="productDiscount"
                                aria-describedby="product-orders-addon"
                                value={validation.values.productDiscount || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.productDiscount && validation.touched.productDiscount ? true : false}
                              />
                              {validation.errors.productDiscount && validation.touched.productDiscount ? (
                                <FormFeedback type="invalid">{validation.errors.productDiscount}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>

                        <Col lg={3} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="product-orders-input"
                            >
                              SKU
                            </label>
                            <div className="input-group mb-3">
                              <Input
                                type="text"
                                className="form-control"
                                id="product-orders-input"
                                placeholder="Enter sku"
                                name="sku"
                                aria-label="sku"
                                aria-describedby="product-orders-addon"
                                value={validation.values.sku || ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.errors.sku && validation.touched.sku ? true : false}
                              />
                              {validation.errors.sku && validation.touched.sku ? (
                                <FormFeedback type="invalid">{validation.errors.sku}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane id="addproduct-metadata" tabId="2">
                       
                       
                      <Row>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Ntag Id
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter ntag id"
                              id="meta-title-input"
                              name="ntagId"
                              value={validation.values.ntagId || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>

                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Type
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter type"
                              id="meta-title-input"
                              name="type"
                              value={validation.values.type || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Box Content 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter box_content"
                              id="meta-title-input"
                              name="boxContent"
                              value={validation.values.boxContent || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col> 
                      </Row>
                      <Row> 
                        <Col lg={6} md={12} sm={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Brand
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter brand"
                              id="meta-title-input"
                              name="brand"
                              value={validation.values.brand || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={6} md={12} sm={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Sub Brand
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Ente sub_brand"
                              id="meta-title-input"
                              name="subBrand"
                              value={validation.values.subBrand || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Series
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter series"
                              id="meta-title-input"
                              name="series"
                              value={validation.values.series || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             NFT
                            </Label> 
                            <Select
                              value={selectedNft}
                              onChange={() => {
                                handleSelectNft();
                              }}
                              options={yesOrNo}
                              name="choices-nft-input"
                              classNamePrefix="select2-selection form-select"
                            />
                            

                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             NFT Link 
                            </Label> 
                            <Select
                              value={nftLink}
                              onChange={(selectedOption) => handleSelectNftLink(selectedOption)}
                              options={yesOrNo}
                              name="choices-publish-nftLink-input"
                              classNamePrefix="select2-selection form-select"
                            /> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Battery Required 
                            </Label>
                            <Select
                              value={batteryRequired} 
                              options={yesOrNo}
                              name="batteryRequired"
                              classNamePrefix="select2-selection form-select"
                              onChange={(selectedOption) => handleSelectBatteryRequired(selectedOption)}
                            />
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Baterry Type 
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter baterry_type"
                              id="meta-title-input"
                              name="baterryType"
                              value={validation.values.baterryType || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Battery Capacity  
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter battery_capacity"
                              id="meta-title-input"
                              name="batteryCapacity"
                              value={validation.values.batteryCapacity || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Age Limit 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter age_limit"
                              id="meta-title-input"
                              name="ageLimit"
                              value={validation.values.ageLimit || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Genre  
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter genre"
                              id="meta-title-input"
                              name="genre"
                              value={validation.values.genre || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Color   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter series"
                              id="meta-title-input"
                              name="color"
                              value={validation.values.color || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Artist
 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter artist"
                              id="meta-title-input"
                              name="artist"
                              value={validation.values.artist || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Artist Link   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter artist_link"
                              id="meta-title-input"
                              name="artist_link"
                              value={validation.values.artist_link || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Affiliation   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter affiliation"
                              id="meta-title-input"
                              name="affiliation"
                              value={validation.values.affiliation || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Made In 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter madeIn"
                              id="meta-title-input"
                              name="madeIn"
                              value={validation.values.madeIn || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Category   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter v"
                              id="meta-title-input"
                              name="category"
                              value={validation.values.category || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Weight   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter weight"
                              id="meta-title-input"
                              name="weight"
                              value={validation.values.weight || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Product Dimension 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter product_dimension"
                              id="meta-title-input"
                              name="productDimension"
                              value={validation.values.productDimension || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Box Size   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter box_size"
                              id="meta-title-input"
                              name="boxSize"
                              value={validation.values.boxSize || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Shipping Weight   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter shipping_weight"
                              id="meta-title-input"
                              name="shippingWeight"
                              value={validation.values.shippingWeight || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row>
                      <Row> 
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-keywords-input"
                            >
                              Vendor Id 
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter vendor_id"
                              id="meta-title-input"
                              name="vendorId"
                              value={validation.values.vendorId || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Date   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter date"
                              id="meta-title-input"
                              name="date"
                              value={validation.values.date || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                          <div className="mb-3">
                            <Label
                              className="form-label"
                              htmlFor="meta-title-input"
                            >
                             Material   
                            </Label> 
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Enter material"
                              id="meta-title-input"
                              name="material"
                              value={validation.values.material || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}/> 
                          </div>
                        </Col>
                      </Row> 

                       
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>

              <div className="text-end mb-3">
                <button type="submit" className="btn btn-primary w-sm">
                  Submit
                </button>
              </div>
            </Form>
          </Col>

          <Col xl={4} lg={4} md={12} sm={12}>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Publish</h5>
              </CardHeader>
              <CardBody>
                <div className="mb-3">
                  <Label
                    htmlFor="choices-publish-status-input"
                    className="form-label"
                  >
                    Status
                  </Label>
                  <Input
                    name="status"
                    type="select"
                    className="form-select"
                    id="choices-publish-status-input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.status || ""
                    }
                  >
                    {productStatus.map((item, key) => (
                      <React.Fragment key={key}>
                        {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                      </React.Fragment>
                    ))}
                  </Input>
                  {validation.touched.status &&
                    validation.errors.status ? (
                    <FormFeedback type="invalid">
                      {validation.errors.status}
                    </FormFeedback>
                  ) : null}
                </div>

                <div>
                  <Label
                    htmlFor="choices-publish-visibility-input"
                    className="form-label"
                  >
                    Visibility
                  </Label>

                  <Select
                    value={selectedVisibility}
                    onChange={() => {
                      handleSelectVisibility();
                    }}
                    options={productVisibility}
                    name="choices-publish-visibility-input"
                    classNamePrefix="select2-selection form-select"
                  />
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Publish Schedule</h5>
              </CardHeader>

              <CardBody>
                <div>
                  <label
                    htmlFor="datepicker-publish-input"
                    className="form-label"
                  >
                    Publish Date & Time
                  </label>
                  <Flatpickr
                    name="publishedDate"
                    id="publishedDate-field"
                    className="form-control"
                    placeholder="Select a date"
                    options={{
                      enableTime: true,
                      altInput: true,
                      altFormat: "d M, Y, G:i K",
                      dateFormat: "d M, Y, G:i K",
                    }}
                    onChange={(e) =>
                      dateformate(e)
                    }
                    value={validation.values.publishedDate || ""}
                  />
                  {validation.touched.publishedDate && validation.errors.publishedDate ? (
                    <FormFeedback type="invalid">{validation.errors.publishedDate}</FormFeedback>
                  ) : null}
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Categories</h5>
              </CardHeader>
              <CardBody>
                <p className="text-muted mb-2">
                  {" "}
                  <Link to="#" className="float-end text-decoration-underline">
                    Add New
                  </Link>
                  Select product category
                </p>



                <Input
                  name="category"
                  type="select"
                  className="form-select"
                  id="category-field"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={
                    validation.values.category || ""
                  }
                >
                  {productCategory.map((item, key) => (
                    <React.Fragment key={key}>
                      {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                    </React.Fragment>
                  ))}
                </Input>
                {validation.touched.category &&
                  validation.errors.category ? (
                  <FormFeedback type="invalid">
                    {validation.errors.category}
                  </FormFeedback>
                ) : null}
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Tags</h5>
              </CardHeader>
              <CardBody>
                <div className="hstack gap-3 align-items-start">
                  <div className="flex-grow-1">
                    <Input
                      className="form-control"
                      placeholder="Enter tags"
                      type="text"
                      name="product_tags"
                      value={validation.values.product_tags || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={validation.errors.product_tags && validation.touched.product_tags ? true : false}
                    />
                    {validation.errors.product_tags && validation.touched.product_tags ? (
                      <FormFeedback type="invalid">{validation.errors.product_tags}</FormFeedback>
                    ) : null}
                  </div>
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">Product Short Description</h5>
              </CardHeader>
              <CardBody>
                <div className="hstack gap-3 align-items-start">
                  <div className="flex-grow-1">
                    <textarea
                      className="form-control"
                      placeholder="Optional: Add a short description for the product"
                      name="product_short_description"
                      rows="3"
                      value={validation.values.product_short_description || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                    ></textarea>
                    {/* Optional fields do not require validation feedback */}
                  </div>
                </div>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddProduct;
